import React from 'react';

export default class Page7 extends React.Component {

    _savePageStatus = (nextPage) => () => {

        this.props.handleChangeMainPage(nextPage)();

        if (this.props.incompletePage)
            this.props.savePageStatus()('HowToChallengeOthersEffectively');
    }

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="circle_title-first"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>Further Information
                                            </div>

                                            <p>If you found this tool useful then you are likely to find the
                                                following tools both insightful and relevant: </p>
                                            <div className="keyquestionpad">
                                                <ul className="greenbullet-list sept">
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToBeAssertive')}>How
                                                        to be assertive</div></li>
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToInfluenceOthers')}>How
                                                        to influence others</div></li>
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToCommunicateEffectively')}>How
                                                        to communicate effectively</div></li>
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToManageYourImpact')}>How
                                                        to manage your impact</div></li>
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToSupportAndChallengeInTandem')}>How
                                                        to support and challenge in tandem </div></li>
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToGiveFeedback')}>How
                                                        to give feedback </div></li>
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToTakeControl')}>How
                                                        to take control.</div></li>

                                                </ul>
                                            </div>
                                            <div className="circle_title"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>REFERENCES
                                            </div>

                                            <ol className="testclass">
                                                <li><p className="further_info_content"><a
                                                    href="http://www.worldflags101.com/other-flags/white-flag.aspx"
                                                    className="link_color thought"> http://www.worldflags101.com/other-flags/white-flag.aspx </a>
                                                </p></li>
                                                <li><p className="further_info_content">Schnall,
                                                    E., &amp; Greenberg, M. J. (2012). Groupthink and the
                                                    Sanhedrin: An analysis of the ancient court of Israel
                                                    through the lens of modern social psychology. <span
                                                        className="subtiltereg">Journal of Management History,</span> 18(3),
                                                    285-294.</p></li>
                                                <li><p className="further_info_content"> Davis, M. et al.
                                                    (2000). <span className="subtiltereg">The Stress and Relaxation Workbook,</span> New
                                                    Harbinger, CA.</p></li>
                                            </ol>


                                            <div className="left-btn">
                                                <div onClick={this.props.handleChangePage('Page6')}
                                                     className="button-next-previous-done thought"> &lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this._savePageStatus('Thought')}
                                                    className="button-next-previous-done thought">Done
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}